import React, { useEffect } from 'react';

interface SearchInfoWindowProps {
  location: { lat: number; lng: number };
  infoWindow: google.maps.InfoWindow | null;
  map: google.maps.Map | null;
  onRadiusSelect: (radius: number, location: { lat: number; lng: number }) => void;
}

const SearchInfoWindow: React.FC<SearchInfoWindowProps> = ({
  location,
  infoWindow,
  map,
  onRadiusSelect
}) => {
  useEffect(() => {
    if (!infoWindow || !map) return;
    
    // Create the content for the info window
    const content = document.createElement('div');
    content.className = 'map-search-info-window';
    content.innerHTML = `
      <div class="map-search-info-window-header">
        <h5>Search Properties</h5>
      </div>
      <p class="map-search-info-window-text">
        Select a radius to find properties around point:
      </p>
      <div class="map-search-info-window-buttons">
        <button id="radius-50" class="map-search-info-window-radius-btn">50M</button>
        <button id="radius-200" class="map-search-info-window-radius-btn">200M</button>
        <button id="radius-500" class="map-search-info-window-radius-btn">500M</button>
      </div>
    `;
    
    infoWindow.setContent(content);
    infoWindow.setPosition(location);
    infoWindow.open(map);
    
    // Add event listeners to buttons with the current location
    const addButtonListeners = () => {
      document.getElementById('close-info-window')?.addEventListener('click', () => {
        infoWindow?.close();
      });
      
      // Capture the current location for use in the radius search
      const currentLocation = { ...location };
      
      document.getElementById('radius-50')?.addEventListener('click', () => {
        if (infoWindow) {
          infoWindow.close();
          
          // Also try to remove any open info windows from DOM
          const openInfoWindows = document.querySelectorAll('.gm-style-iw-a');
          openInfoWindows.forEach(el => {
            if (el.parentNode) {
              el.parentNode.removeChild(el);
            }
          });
        }
        
        // Add a small delay before starting the search
        setTimeout(() => {
          onRadiusSelect(50, currentLocation);
        }, 50);
      });
      
      document.getElementById('radius-200')?.addEventListener('click', () => {
        if (infoWindow) {
          infoWindow.close();
          const openInfoWindows = document.querySelectorAll('.gm-style-iw-a');
          openInfoWindows.forEach(el => {
            if (el.parentNode) {
              el.parentNode.removeChild(el);
            }
          });
        }
        
        setTimeout(() => {
          onRadiusSelect(200, currentLocation);
        }, 50);
      });
      
      document.getElementById('radius-500')?.addEventListener('click', () => {
        if (infoWindow) {
          infoWindow.close();
          const openInfoWindows = document.querySelectorAll('.gm-style-iw-a');
          openInfoWindows.forEach(el => {
            if (el.parentNode) {
              el.parentNode.removeChild(el);
            }
          });
        }
        
        setTimeout(() => {
          onRadiusSelect(500, currentLocation);
        }, 50);
      });
    };
    
    // Add a small delay to ensure the DOM elements are available
    setTimeout(addButtonListeners, 100);
    
    // Clean up function
    return () => {
      // Remove event listeners if needed
      document.getElementById('radius-50')?.removeEventListener('click', () => {});
      document.getElementById('radius-200')?.removeEventListener('click', () => {});
      document.getElementById('radius-500')?.removeEventListener('click', () => {});
      document.getElementById('close-info-window')?.removeEventListener('click', () => {});
    };
  }, [location, infoWindow, map, onRadiusSelect]);

  // This component doesn't render anything directly
  return null;
};

export default SearchInfoWindow; 